import gql from 'graphql-tag';
import { client } from './client';

export const ORG_MEMBER_FIELDS = gql`
  fragment orgMemberInfo on OrganizationMemberSchema {
    orgId
    loginId
    firstname
    lastname
    initials
    email
    permissions
    isDefaultLeadAssignment
    isLeadContact
    profileImage {
      key
      resolutions
      status
    }
    orgLeadContact {
      id
      organizationId
      loginId
    }
  }
`;

export const fetchOrgMembers = async (variables) => {
  const results = await client.query({
    query: gql`
    ${ORG_MEMBER_FIELDS}
    query getOrganizationMembers(
      $orgId: Int!
    ) {
      organizationMembers(
        orgId: $orgId
      ) {
        ...orgMemberInfo
      }
    }
    `,
    variables,
    errorPolicy: 'all',
  });

  return results;
};
